let last_scroll = 0;

$(window).scroll(function(){
    if(window.innerWidth<=992){
        let productItems = document.querySelectorAll('.product-item');
        productItems.forEach((productItem) => {
            let blockHeight = productItem.getBoundingClientRect().height
            let windowHeight = window.innerHeight
            let id = productItem.getAttribute('data-id');
            console.log(windowHeight)
            console.log(id,productItem.getBoundingClientRect())

            if(productItem.getBoundingClientRect().y>=0 && productItem.getBoundingClientRect().y<window.innerHeight* .7){
                document.querySelector(`.product-nav._mob [data-id="${id}"]`).classList.add('_active')
            } else{
                document.querySelector(`.product-nav._mob [data-id="${id}"]`).classList.remove('_active')
            }
        })
        $(".product-item").each(function(){

        })
    }
    if(window.scrollY > last_scroll){
        $(".sidebar").addClass("_hide");
    } else{
        $(".sidebar").removeClass("_hide");
    }
    last_scroll = window.scrollY;
});

$(".product-nav__item").click(function (e) {
    let id = +$(this).attr("data-id")
    if(window.innerWidth>992){
        e.preventDefault()
        slideTo(id);
        $(".product-nav__item").removeClass("_active");
        $(this).addClass("_active");
    } else{
        console.log(id)
        $('html,body').animate({
            scrollTop: $(`.product-item[data-id="${id}"]`).offset().top
        });
    }
})

function setActiveTab() {
    let currentSlideId = +$(".parallax-active").attr("data-id")
    $(".product-nav__item").removeClass("_active");
    $(`.product-nav__item[data-id="${currentSlideId}"]`).addClass("_active");
}

function slideTo(nextSlideId) {
    let currentSlideId = +$(".parallax-active").attr("data-id")
    let moveCount = nextSlideId - currentSlideId;


    if(moveCount > 0) {
        for (let i = 0; i < moveCount; i++) {
            nextSlide()
        }
    } else{
        for (let i = 0; i < (moveCount * -1); i++) {
            prevSlide()
        }
    }



    // $(".parallax-active").removeClass("parallax-active")
    // $(".parallax-active").addClass("prev")
    // $(slide).addClass("parallax-active")
    // $(slide).prev().addClass("prev")
    // $(slide).next().addClass("queue")
}